module.exports = __webpack_public_path__ + "static/media/EllenWu_Resume.3d38206e.pdf";